import Vue from 'vue'
import Default from "@/layouts/Default.vue";
import Seller from "@/layouts/Seller.vue";
import Auth from "@/layouts/Auth.vue";

export const registerLayouts = function () {
    Vue.component('default-layout', Default);
    Vue.component('seller-layout', Seller);
    Vue.component('auth-layout', Auth);
}
